import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { breakpoints, colors } from "@/styles/utils/vars";
import { ButtonBase } from "@/ui/Button/StyledButton";
import { StyledFieldWrapper } from "@/ui/Field/StyledField";
export const cssIsShowExpand = "cssIsShowExpand_cjb9az5";
export const cssVisibleExpand = "cssVisibleExpand_c7lwa9i";
export const cssButtonMore = "cssButtonMore_c1iw31tk";
export const StyledControls = /*#__PURE__*/styled('div')({
  name: "StyledControls",
  class: "StyledControls_s1rctpri"
});
export const ControlGroup = /*#__PURE__*/styled('div')({
  name: "ControlGroup",
  class: "ControlGroup_c169emf6"
});
export const StyledControlsGeneral = /*#__PURE__*/styled(ControlGroup)({
  name: "StyledControlsGeneral",
  class: "StyledControlsGeneral_spd1ji9"
});
export const cssButtonToggleProducts = "cssButtonToggleProducts_cei7wha";

require("./StyledControls.linaria.module.css!=!../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledControls.tsx");